import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PartnerPlanService from "services/PartnerPlanService";

const initialState = {
  plans: [],
  plan: null,
  loading: false,
  detailLoading: false,
  error: null,
};

export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async ({ visibility, title } = {}, { rejectWithValue }) => {
    try {
      const response = await PartnerPlanService.getPlans({ visibility, title });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        error.message ||
        "Erreur lors de la récupération des plans"
      );
    }
  }
);

export const fetchPlanDetail = createAsyncThunk(
  "plans/fetchPlanDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PartnerPlanService.getPlan(id);
      return response.data?.data ?? response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        error.message ||
        "Erreur lors de la récupération du plan"
      );
    }
  }
);

export const createPlan = createAsyncThunk(
  "plans/createPlan",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await PartnerPlanService.createPlan(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        error.message ||
        "Erreur lors de la création du plan"
      );
    }
  }
);

export const updatePlan = createAsyncThunk(
  "plans/updatePlan",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PartnerPlanService.updatePlan(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        error.message ||
        "Erreur lors de la mise Ã  jour du plan"
      );
    }
  }
);

export const removePlan = createAsyncThunk(
  "plans/removePlan",
  async (id, { rejectWithValue }) => {
    try {
      await PartnerPlanService.deletePlan(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        error.message ||
        "Erreur lors de la suppression du plan"
      );
    }
  }
);

const planSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    clearPlanDetail: (state) => {
      state.plan = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload?.data || [];
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchPlanDetail.pending, (state) => {
        state.detailLoading = true;
        state.error = null;
      })
      .addCase(fetchPlanDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.plan = action.payload;
      })
      .addCase(fetchPlanDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(createPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPlan.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(updatePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePlan.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(removePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removePlan.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = state.plans.filter((plan) => plan.id !== action.payload);
      })
      .addCase(removePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearPlanDetail } = planSlice.actions;
export default planSlice.reducer;
